import { useEffect, useState } from 'react';
import { downloadNewsCoverPhoto, NewsInfo } from '../../misc/lib/news';
import './NewsList';

const NewsCard = (props: NewsInfo) => {
  const [ cover, setCover ] = useState<File>();

  useEffect(() => {
    downloadNewsCoverPhoto(props.id, props.coverPath).then((f) => {
      setCover(f);
    }).catch((err) => console.error(err));
  }, [ props ]);

  return (
    <div className="app-news-card">
      <div style={ {
        backgroundImage: !!cover ? `url(${ URL.createObjectURL(cover) })` : 'none'
      } }></div>
      <h3><b>{ props.title }</b></h3>
    </div>
  );
};

export default NewsCard;
